
import { Component, Prop } from 'vue-property-decorator'
import {Base} from '~/core/Base'

@Component
export default class JSONPreview extends Base {
  @Prop({ default: {} }) json!: any;
}
